import { ComponentChildren } from 'preact';

type Props = {
  children: ComponentChildren;
  color?: string;
};

export function HighlightText({ children, color = '#FEF08A' }: Props) {
  return (
    <span class="font-bold px-1 rounded" style={`background-color: ${color}`}>
      {children}
    </span>
  );
}
